import React from 'react';

const Title = props => (
  <h1 className="mb-4 d-block text-yellow text-shadow-dark">{props.text}</h1>
);

export default Title;
